var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filterSlider"},[_c('div',{staticClass:"filterSlider__box"},[_c('img',{attrs:{"src":_vm.Filterbanner,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }